export const GENERAL_ERROR_MESSAGE = $localize`Algo ha ido mal. Por favor, inténtalo de nuevo`;
